import type { BillingCountryOptions } from './billingTypes'

export function browserTimeZone(): string | undefined {
  const zone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return zone || undefined
}

/** No product fallback: a browser zone outside the API's offer asks the user. */
export function countryForTimeZone(zone: string | undefined, options: BillingCountryOptions): string | undefined {
  if (zone === undefined) return undefined
  const exact = options.selectableCountries.find((code) => options.countryTimeZones[code] === zone)
  if (exact !== undefined) return exact
  // ICU resolves IANA aliases (including ROK and Singapore) to canonical zones.
  // Country codes and representative zones still come solely from the API.
  try {
    const canonical = Intl.DateTimeFormat('en', { timeZone: zone }).resolvedOptions().timeZone
    return options.selectableCountries.find((code) => options.countryTimeZones[code] === canonical)
  } catch (error) {
    if (error instanceof RangeError) return undefined
    throw error
  }
}
